{
	"title": "Terms and Conditions",
	"backTitle": "Back"
}
